import React from 'react'

import clsx from 'clsx'

import classes from './Divider.module.scss'

const Divider = () => {
  return (
    <div className={clsx('Divider', classes.root)}>
      <div className={classes.particlesContainer}>
        {Array(5)
          .fill()
          .map((_, i) => i)
          .map(i => (
            <div className={classes.particle} key={`divider-particle-${i}`} />
          ))}
      </div>
    </div>
  )
}

export default Divider
